import { NgxExcelModelColumnRules, NgxExcelModelColumnRule } from '../models/models';
import { Observable } from 'rxjs';

export abstract class INgxExcelDataSource<T> {
  /**
   * è·å¾æ¨¡åä¸»é®å¼
   * @param model æ¨¡å
   */
  public abstract getPrimaryKey(model: T): string;

  /**
   * è·å¾ææå­æ®µçæ¨¡åè§å
   */
  public abstract getRules(): NgxExcelModelColumnRules<T>;

  /**
   * è·å¾æå®å­æ®µçæ¨¡åè§åï¼æå¡ç©¿éï¼
   * @param name å­æ®µå
   */
  public abstract getRule(name: string): NgxExcelModelColumnRule<T>;

  /**
   * è·å¾æå¡å¨ååºæåä¸æ¬¡ååºçåæ°æ®
   */
  public abstract getResponseMetas(): { [name: string]: any };

  /**
   * è·å¾æ¨¡ååè¡¨çèµæºååº
   * @param filters è¯·æ±åè¡¨ç­éåæ°
   * @param page é¡µç 
   * @param pageSize é¡µé¢é¿åº¦
   */
  public abstract getList(filters?: { [name: string]: string | string[] }, page?: number, pageSize?: number): Observable<T[]>;

  /**
   * æ´æ°æåå»ºå®ä¾æ¨¡å
   * @param payload è¯·æ±åæ°ææ¨¡åå¯¹è±¡
   * @param primaryKey æ¨¡åä¸»é®(å¦æä¾ä¸»é®ä»£è¡¨æ´æ°æ¨¡å, å¦ååå»ºæ¨¡å)
   */
  public abstract save(payload: { [name: string]: any }, primaryKey?: string): Observable<T>;

}
